<template>
  <div class="home"></div>
</template>
<script>
import '@/assets/images/amanda-vick-eRAq9asBIy4-unsplash.jpg';

export default {};
</script>

<style scoped>
.home {
  background-image: url('~@/assets/images/amanda-vick-eRAq9asBIy4-unsplash.jpg');
  background-size: cover;
  height: 100%;
}

.large {
  width: 100%;
}
</style>
